/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Select_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Please select an Event Group to sync." |
*
* @param {Offline_Sync_Select_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_select_event_group = /** @type {((inputs?: Offline_Sync_Select_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Select_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez sélectionner un groupe d'événements à synchroniser.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Ereignisgruppe zum Synchronisieren aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un gruppo eventi da sincronizzare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группу событий для синхронизации.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selecciona un grupo de eventos para sincronizar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择要同步的事件组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期するイベントグループを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक करने के लिए कृपया एक इवेंट समूह चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um grupo de eventos para sincronizar.")
	return /** @type {LocalizedString} */ ("Please select an Event Group to sync.")
});